import React from 'react';
import cx from 'classnames';

import {
  TypographyVariant,
  TypographyElement,
  Heading1,
  Heading3,
  Heading2,
  Heading4,
  Heading5,
  Heading6,
  Subtitle1,
  Subtitle2,
  Body1,
  Body2,
  Caption,
  Overline,
  ButtonText,
  Tag,
} from '../Typography';

import styles from './index.module.scss';

const TypographyVariantElements: Record<TypographyVariant, React.ElementType> =
  {
    h1: Heading1,
    h2: Heading2,
    h3: Heading3,
    h4: Heading4,
    h5: Heading5,
    h6: Heading6,
    subtitle1: Subtitle1,
    subtitle2: Subtitle2,
    body1: Body1,
    body2: Body2,
    caption: Caption,
    overline: Overline,
    button: ButtonText,
    tag: Tag,
  };

export interface TypographySwitcherProps {
  mobile: TypographyVariant;
  tablet: TypographyVariant;
  desktop: TypographyVariant;
  element?: TypographyElement;
  children: React.ReactNode;
  className?: string;
}

const TypographySwitcher: React.FC<TypographySwitcherProps> = ({
  mobile,
  tablet,
  desktop,
  children,
  element,
  className,
}) => {
  const MobileElement = TypographyVariantElements[mobile];
  const TabletElement = TypographyVariantElements[tablet];
  const DesktopElement = TypographyVariantElements[desktop];

  return (
    <>
      <MobileElement element={element} className={cx(styles.mobile, className)}>
        {children}
      </MobileElement>

      <TabletElement element={element} className={cx(styles.tablet, className)}>
        {children}
      </TabletElement>
      <DesktopElement
        element={element}
        className={cx(styles.desktop, className)}
      >
        {children}
      </DesktopElement>
    </>
  );
};

export default TypographySwitcher;
